exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding {\r\n  padding: unset;\r\n}\r\n\r\n.toRight {\r\n  float: right;\r\n}\r\n\r\n.buffer-bottom {\r\n  padding-bottom: 3rem;\r\n}\r\n\r\n.c-menu-sm {\r\n  display: none;\r\n}\r\n\r\n@media (max-width: 820px) {\r\n  .c-menu {\r\n    display: none;\r\n  }\r\n\r\n  .c-menu-sm {\r\n    display: inline-block;\r\n  }\r\n}\r\n\r\n.spec-group-folder {\r\n  padding-right: 0.3rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/qualifications/components/qualifications-list/qualifications-list.component.css
// module id = ../../../../../src/app/content-page/common/qualifications/components/qualifications-list/qualifications-list.component.css
// module chunks = main